import { render } from "./WhatsAppBroadcastView.vue?vue&type=template&id=a9ca22a6&scoped=true"
import script from "./WhatsAppBroadcastView.vue?vue&type=script&lang=js"
export * from "./WhatsAppBroadcastView.vue?vue&type=script&lang=js"

import "./WhatsAppBroadcastView.vue?vue&type=style&index=0&id=a9ca22a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9ca22a6"]])

export default __exports__